import { useEffect, useState } from 'react';

const INITIAL_TITLE_TOP = 265;
const BUTTONS_OFFSET_FROM_BOTTOM = 200;

export default function useFormIframe({ displayForm, titlesMap, onProgressReady }) {
  const [currentTitle, setCurrentTitle] = useState(titlesMap?.[1] ?? '');
  const [iframeHeight, setIframeHeight] = useState('100px');

  useEffect(() => {
    if (!displayForm) return;

    let attempts = 0;
    let clickedNext = false;

    const intervalId = setInterval(() => {
      attempts += 1;
      const iframe = document.querySelector('iframe');
      if (!iframe || !iframe.contentDocument) {
        if (attempts > 300) clearInterval(intervalId);
        return;
      }
      try {
        const doc = iframe.contentDocument;
        const nextButton = doc.getElementById('form-pagebreak-next_157');
        const span = doc.getElementById('progressTextCompleted');

        if (nextButton && !clickedNext) {
          nextButton.click();
          clickedNext = true;
        }
        if (span) span.textContent = 'Terminé';

        if (clickedNext || span) clearInterval(intervalId);
      } catch {
        if (attempts > 300) clearInterval(intervalId);
      }
    }, 200);

    return () => clearInterval(intervalId);
  }, [displayForm]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'pageChanged' && event.data?.number) {
        const newTitle = titlesMap?.[event.data.number];
        if (newTitle) setCurrentTitle(newTitle);
      }
      if (event.data?.iframeHeight) {
        setIframeHeight(`${event.data.iframeHeight}px`);
      }
      if (event.data?.type === 'progressReady') {
        onProgressReady?.();
      }
      if (event.data === 'pageChanged') {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 200);
      }
    };

    const handleScroll = () => {
      const titleElement = document.getElementById('title');
      const iframe = document.querySelector('iframe');
      if (titleElement && iframe) {
        const scrollTop = window.scrollY;
        const titleRect = titleElement.getBoundingClientRect();
        const iframeRect = iframe.getBoundingClientRect();

        const buttonsPositionFromBottom = iframeRect.bottom - BUTTONS_OFFSET_FROM_BOTTOM;
        const titleTop = Math.max(INITIAL_TITLE_TOP - scrollTop, 75);
        titleElement.style.top = `${titleTop}px`;

        if (buttonsPositionFromBottom - titleRect.height <= 75) {
          titleElement.style.position = 'absolute';
          titleElement.style.top = `${buttonsPositionFromBottom - titleRect.height}px`;
        } else {
          titleElement.style.position = 'fixed';
        }
      }
    };

    window.addEventListener('message', handleMessage);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('message', handleMessage);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [titlesMap, onProgressReady]);

  return { currentTitle, iframeHeight };
}